import Card from '~/components/common/Card'

const BasketSkeletonLoader = () => (
    <>
        <Card>
            <ul className="divide-y divide-dashed divide-gray-600">
                <li className="p-4 grid grid-cols-3 gap-4 h-32">
                    <div className="size-full animate-pulse bg-gray-800/80 rounded-md" />
                    <div className="size-full col-span-2 animate-pulse bg-gray-800/80 rounded-md" />
                </li>
                <li className="p-4 grid grid-cols-3 gap-4 h-32">
                    <div className="size-full animate-pulse bg-gray-800/80 rounded-md" />
                    <div className="size-full col-span-2 animate-pulse bg-gray-800/80 rounded-md" />
                </li>
            </ul>
            <div className="mt-6 border-t border-gray-600 p-4 space-y-4">
                <div className="h-8 max-w-36 animate-pulse bg-gray-800 rounded-md" />
                <div className="h-8 animate-pulse bg-gray-800/80 rounded-md" />
                <div className="h-8 animate-pulse bg-gray-800/80 rounded-md" />
                <div className="h-8 animate-pulse bg-gray-800/80 rounded-md" />
            </div>
        </Card>
        <div className="sticky bottom-4 h-12 mt-6 w-full animate-pulse bg-violet-800/80 rounded-md" />
    </>
)

export default BasketSkeletonLoader
